import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { useSvgId } from 'src/lib/hooks/useSvgId';

export const IconAiPen = memo(
  forwardRef((props, ref) => {
    const svgId = useSvgId();
    return (
      <SvgIcon
        {...props}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath={`url(#${svgId})`}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.09697 0.399414C4.45549 0.399413 4.76388 0.653158 4.83293 1.00497C5.06816 2.20351 6.01014 3.14807 7.15784 3.37879C7.5146 3.45051 7.76094 3.76438 7.76017 4.11493C7.76094 4.46548 7.5146 4.77935 7.15784 4.85107C6.01006 5.08181 5.06785 6.02644 4.83264 7.22488C4.76359 7.5767 4.4552 7.83044 4.09668 7.83044C3.73815 7.83044 3.42977 7.57669 3.36072 7.22488C3.1255 6.02635 2.18351 5.08179 1.0358 4.85107C0.679041 4.77935 0.432702 4.46548 0.433473 4.11493C0.432702 3.76438 0.679041 3.45051 1.0358 3.37879C2.18359 3.14805 3.1258 2.20342 3.36101 1.00497C3.43005 0.653161 3.73844 0.399415 4.09697 0.399414ZM3.0155 4.11496C3.43403 4.41428 3.80029 4.78491 4.09672 5.20863C4.39322 4.78488 4.75955 4.41423 5.17814 4.1149C4.75962 3.81558 4.39336 3.44495 4.09693 3.02123C3.80044 3.44498 3.43409 3.81563 3.0155 4.11496Z"
            fill="#currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8451 4.888C11.8451 4.88806 11.8452 4.88794 11.8451 4.888L11.4742 5.26016L13.3284 7.11437L13.6888 6.75884C14.2049 6.19378 14.177 5.3693 13.697 4.888C13.1629 4.35236 12.3501 4.38182 11.8451 4.888ZM13.7624 8.79327C13.7976 8.76859 13.8311 8.74054 13.8625 8.70912C13.8914 8.6802 13.9175 8.64951 13.9407 8.6174L14.7548 7.81434C14.7624 7.80686 14.7698 7.79921 14.7771 7.79141C15.82 6.67094 15.8453 4.9179 14.7591 3.82879C13.6122 2.6787 11.8472 2.76173 10.783 3.82879L9.90024 4.71457C9.89472 4.71976 9.88926 4.72506 9.88387 4.73045C9.87786 4.73646 9.87197 4.74255 9.86621 4.74871L4.19391 10.4402C4.09997 10.5345 4.03281 10.6521 3.9993 10.7808L2.99061 14.6582C2.92359 14.9158 2.99813 15.1896 3.18648 15.3777C3.37482 15.5658 3.64875 15.64 3.90626 15.5726L7.77288 14.5611C7.90004 14.5279 8.01621 14.4618 8.10978 14.3695L13.7624 8.79327ZM12.2606 8.16781L10.4154 6.32261L5.39982 11.3552L4.76441 13.7977L7.19918 13.1607L12.2606 8.16781Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="16"
              height="16"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
